import { Typography } from "@mui/material";
import { selectMtPoItems } from "src/pages/CreateEditManualTransfer/slice/ManualTransferSelectors";
import { useAppSelector } from "src/store/hooks";

const Cost = ({ rowData }: { rowData: any }) => {
  const { itemId } = rowData;
  const poItems: any = useAppSelector(selectMtPoItems);
  const currentPoItem = poItems?.find(
    (row: any) => row.itemId === itemId
  );
  const netPrice = currentPoItem?.netPrice?.slice(1) || 0;
  const currentReceived = currentPoItem?.received || 0;

  const cost = +netPrice * +currentReceived;
  const costDecimalled = cost.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  return (
    <Typography
      data-testid="cost-decimalled"
      variant="subtitle2"
      color="grey.900"
      fontWeight={"normal"}
    >
      ${costDecimalled}
    </Typography>
  );
};

export default Cost;
